import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/commission.scss';
class CommissionViewer extends React.Component {
    render() {
        const restProps = omit(this.props, [
            'theme'
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: 'da-editor-commission'
        }, /*#__PURE__*/ React.createElement(BaseViewer, _extends({
            theme: this.theme
        }, restProps, {
            fixedParagraph: false
        })));
    }
    constructor(props){
        super(props);
        this.theme = mergeTheme(baseTheme, this.props.theme);
    }
}
export { CommissionViewer as default };
